<template>
  <v-layout row justify-center>
    <v-dialog v-model="editExpenseDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title">Editar despesa</v-card-title>
        <v-form ref="editExpenseForm" v-model="validEditExpenseForm">
          <v-layout row wrap>
            <v-flex xs12 px-4>
              <v-text-field
                v-model="expenseDataForm.code_user"
                label="Código"
                :rules="$store.state.formRules.required"
              />
            </v-flex>
            <v-flex xs12 px-4>
              <v-text-field
                v-model="expenseDataForm.name_user"
                label="Descrição"
                :rules="$store.state.formRules.required"
              />
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blueGrey darken-1" flat @click="closeEditExpenseDialog">Cancelar</v-btn>
            <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: {
    getUserExpenses: Function,
    editExpenseDialog: Boolean,
    closeEditExpenseDialog: Function,
    expenseData: Object
  },
  watch: {
    editExpenseDialog: function(val) {
      if (val) {
        this.expenseDataForm = { ...this.expenseData };
        //alert(val);
        //console.log(this.expenseData);
      } else {
        this.expenseDataForm = {};
        this.$refs.editExpenseForm.resetValidation();
      }
    }
  },
  data() {
    return {
      expenseDataForm: {},
      validEditExpenseForm: true
    };
  },
  methods: {
    doSave() {
      if (!this.$refs.editExpenseForm.validate()) {
        return;
      }
      let query = this.expenseDataForm;
      let obj = {
        url: "/api/expenseGroup/" + this.expenseDataForm.id,
        query: query,
        method: "patch"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        if (!response) {
          return;
        }
        let opts = {
          message: "Grupo de despesa alterado com sucesso",
          type: "success"
        };
        this.$store.commit("showAlert", opts);
        this.getUserExpenses();
        this.closeEditExpenseDialog();
      });
    }
  }
};
</script>